import Vue from 'vue'
import VueI18n from 'vue-i18n'
import Cookies from 'js-cookie'
// import Actions from '@/constants/action'
// import store from '@/store'
import enLibLocale from 'vant/lib/locale/lang/en-US'
import zhLibLocale from 'vant/lib/locale/lang/zh-CN'
import enLocale from './en'
import zhLocale from './zh'

Vue.use(VueI18n)

// 系统默认语言
let lang = navigator.language
if (lang.indexOf('zh') !== -1) {
  lang = 'zh'
}
if (lang.indexOf('en') !== -1) {
  lang = 'en'
}

const messages = {
  en: {
    ...enLibLocale,
    ...enLocale
  },
  zh: {
    ...zhLibLocale,
    ...zhLocale
  }
}

const i18n = new VueI18n({
  locale: Cookies.get('language') || lang,
  messages
})

export default i18n
